/** What a download button reads while its file is being prepared. */
export const DOWNLOAD_PREPARING_LABEL = 'Preparing…';
